import { motion } from "framer-motion";
import styled from "styled-components";

export const HomePageWrapper = styled(motion.div)`
  position: relative;
  min-height: 100vh;
  margin: 0 auto;
`;
